var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.46 3.54a.65.65 0 0 1 0 .92L6.92 8l3.54 3.54a.65.65 0 1 1-.92.92l-4-4a.65.65 0 0 1 0-.92l4-4a.65.65 0 0 1 .92 0Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40NTk2IDMuNTQwMzhDMTAuNzEzNSAzLjc5NDIyIDEwLjcxMzUgNC4yMDU3OCAxMC40NTk2IDQuNDU5NjJMNi45MTkyMyA4TDEwLjQ1OTYgMTEuNTQwNEMxMC43MTM1IDExLjc5NDIgMTAuNzEzNSAxMi4yMDU4IDEwLjQ1OTYgMTIuNDU5NkMxMC4yMDU4IDEyLjcxMzUgOS43OTQyMiAxMi43MTM1IDkuNTQwMzcgMTIuNDU5Nkw1LjU0MDM3IDguNDU5NjJDNS4yODY1MyA4LjIwNTc4IDUuMjg2NTMgNy43OTQyMiA1LjU0MDM3IDcuNTQwMzhMOS41NDAzNyAzLjU0MDM4QzkuNzk0MjIgMy4yODY1NCAxMC4yMDU4IDMuMjg2NTQgMTAuNDU5NiAzLjU0MDM4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";